import PaymentAddressView from "./view";
import { useNavigate } from "react-router-dom";
import usePaymentAddressForm from "./hooks/usePaymentAddressForm";

export default function PaymentAddress() {
  const navigate = useNavigate();

  const {
    toggleModal,
    isVisibleModal,
    toggleErrorModal,
    isVisibleErrorModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    errors,
    editable,
  } = usePaymentAddressForm(navigate);

  const goBack = () => navigate(-1);

  return (
    <PaymentAddressView
      goBack={goBack}
      isDisabled={isDisabled}
      editable={editable}
      isLoading={isLoading}
      register={register}
      errors={errors}
      handleSubmit={handleSubmit}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      isVisibleErrorModal={isVisibleErrorModal}
      toggleErrorModal={toggleErrorModal}
    />
  );
}
